/**
 * Created by linjianxi on 2017/1/18.
 */
export const getRedData = (state) => {
  return state
}



// WEBPACK FOOTER //
// ./src/vuex/modules/packet/getter.js